import React from "react";
import { motion } from "framer-motion";
import DummyProductImage from "../Components/DummyImage";

const galleryItems = [
  { title: "High-Purity Tin Ingots", category: "Ingots", type: "tin" },
  { title: "Refined Lead Ingot Stack", category: "Ingots", type: "lead" },
  { title: "Industrial Lead Metal Slabs", category: "Ingots", type: "lead metal" },
  { title: "JK Solder Wire Spools", category: "Solder", type: "solder wire" },
  { title: "Eutectic Solder Sticks", category: "Solder", type: "solder stick" },
  { title: "Star Solder Stick Batch", category: "Solder", type: "star solder stick" },
  { title: "Industrial Solder Ingot Bars", category: "Ingots", type: "solder ingot" },
  { title: "Solder Heavy Bar Inventory", category: "Solder", type: "solder bar" },
  { title: "Solder Round Chaka Discs", category: "Solder", type: "solder round chaka" },
  { title: "Forged Copper Axe Ingots", category: "Copper", type: "copper axe" },
  { title: "High-Grade Zinc Ingot", category: "Zinc", type: "zinc" },
  { title: "99.9% Pure Tin Ingot Bundles", category: "Ingots", type: "tin ingot" },
];

const Gallery = () => {
  return (
    <div className="page-wrapper">
      <section className="page-banner">
        <div className="page-banner-container">
          <h1>Product &amp; Facility Gallery</h1>
          <p>Authentic Photographic Showcase of JK Metal &amp; Alloys Products &amp; Materials</p>
        </div>
      </section>

      <section className="gallery-section">
        <div className="container">
          <div className="gallery-grid">
            {galleryItems.map((item, idx) => (
              <motion.div 
                className="gallery-card" 
                key={idx}
                whileHover={{ scale: 1.03 }}
                transition={{ duration: 0.3 }}
              >
                <DummyProductImage title={item.title} category={item.category} type={item.type} />
                <div className="gallery-card-title">{item.title}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;